import React from "react"
import PropTypes from "prop-types"

const Summary = props => {
  Summary.propTypes = {
    message: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    updatedAtDescription: PropTypes.string,
    updatedAtFormatted: PropTypes.string
  }

  return (
    <li className="p-4 flex flex-col flex-auto" data-status={props.status}>
      <p className="message flex flex-row flex-auto text-sm text-gray-700 font-semibold items-center">
        {props.message}
      </p>
      {props.updatedAtDescription && (
        <p title={props.updatedAtFormatted} className="text-xs text-gray-700">
          {props.updatedAtDescription} ago
        </p>
      )}
    </li>
  )
}

export { Summary }
